import React from 'react';
import './CriticalInfoBlock.css';

export default function CriticalInfoBlock({ text }) {
  return (
    <div className='criticalInfoBlock'>
      <p className='criticalInfoBlock__text'>{text}</p>
    </div>
  );
}
